<template>
  <div class="container menu-wrapper">
    <div class="menu-operation" style="margin-bottom: 1vw">
      <div class="menu-operation-item">
        <div class="four-font-wrapper" style="margin-right: 1vw" @click="showAddModal(1)"><div class="icon-font">&#xe605;</div>添加菜单</div>
        <div class="four-font-wrapper" style="margin-right: 1vw" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>
      </div>
      <div class="menu-operation-item">
        <div class="input-wrapper" style="margin-right: 1vw">
          <input placeholder="请输入关键字" v-model="search.value"/>
        </div>
        <div class="query button" @click="handleSearch(true)">查询</div>
      </div>
    </div>
    <div class="loading-data" v-if="loading">
      <i class="el-icon-loading"></i>
      <div>加载中，请稍后···</div>
    </div>
    <el-table
      v-show="!loading"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @expand-change="handleExpandChange"
      row-key="id"
      :expand-row-keys="expandRowKeys"
      :tree-props="{children: 'children'}">
      <el-table-column
        type="selection">
      </el-table-column>
      <el-table-column
        prop="name"
        label="菜单名称">
      </el-table-column>
      <el-table-column
        label="菜单编号">
        <template slot-scope="scope">
          <el-popover
            placement="top"
            title=""
            trigger="hover"
            :content="scope.row.code">
            <div class="popover" style="width: 10vw;text-align: center" slot="reference">{{scope.row.code}}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="父级菜单">
        <template slot-scope="scope">
          <div>{{scope.row.pname || '--'}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="请求地址">
        <template slot-scope="scope">
          <el-popover
            placement="top"
            title=""
            trigger="hover"
            :content="scope.row.url">
            <div class="popover" style="width: 10vw;text-align: center" slot="reference">{{scope.row.url}}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="num"
        label="排序">
      </el-table-column>
      <el-table-column label="是否是菜单">
        <template slot-scope="scope">
          <div :class="{'color-red': scope.row.ismenu !== 2}">{{scope.row.ismenu === 2 ? '是' : '否'}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="detail-btn item-look" style="margin-right: 0.5vw" @click="showAddModal(2, scope.row)">修改</div>
          <div class="detail-btn item-delete" @click="deleteSingle(scope.row.id)">删除</div>
        </template>
      </el-table-column>
    </el-table>
    <transition name="fade">
      <div class="alert-box" v-if="show">
        <div class="alert-content">
          <div class="alert-content-title">删除提醒</div>
          <div class="alert-content-msg">是否确认删除选中数据?</div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="cancelDelete">取消</div>
            <div class="btn-confirm button" @click="confirmDelete">确认</div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="alert-box" v-if="showAdd">
        <div class="alert-content" style="width: auto;padding: 1vw 2vw">
          <div class="alert-content-title">{{mType === 1 ? '添加菜单' : '修改菜单'}}</div>
          <div class="alert-content-msg" style="width: 100%;flex-direction: column">
            <div class="alert-list">
              <div class="input-contain" style="margin-right: 2vw">
                <div class="input-title" style="padding-left: 2.67vw">名称：</div>
                <div class="input-wrapper">
                  <input placeholder="" v-model="item.name"/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">请求地址：</div>
                <div class="input-wrapper">
                  <input placeholder="" v-model="item.url"/>
                </div>
              </div>
            </div>
          </div>
          <div class="alert-content-msg" style="width: 100%;flex-direction: column;position: relative;z-index: 99">
            <div class="alert-list">
              <div class="input-contain" style="margin-right: 2vw">
                <div class="input-title" style="padding-left: 0.89vw">菜单编号：</div>
                <div class="input-wrapper">
                  <input placeholder="" v-model="item.code"/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 1.78vw">排序：</div>
                <div class="input-wrapper">
                  <input placeholder="" v-model="item.num"/>
                </div>
              </div>
            </div>
          </div>
          <div class="alert-content-msg" style="width: 100%;flex-direction: column;position: relative;z-index: 9999">
            <div class="alert-list">
              <div class="input-contain" style="margin-right: 2vw">
                <div class="input-title" style="padding-left: 0.89vw">父级菜单：</div>
                <TreeSingle :content="title" :items="menuData" :editCheckId="editCheckId" v-on:sendInfo = "showTreeInfo"></TreeSingle>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 1.78vw">图标：</div>
                <div class="input-wrapper">
                  <input placeholder="" v-model="item.icon"/>
                </div>
              </div>
            </div>
          </div>
          <div class="alert-content-msg" style="width: 100%;flex-direction: column">
            <div class="alert-list">
              <div class="input-contain">
                <div class="input-title">是否是菜单：</div>
                <DropDownSingle :content="item.ismenu === 2 ? '是' : '否'" :items="judgeData" v-on:sendInfo = "showInfo"></DropDownSingle>
            </div>
            </div>
          </div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="cancelAdd">取消</div>
            <div class="btn-confirm button" @click="confirmAdd">确认</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DropDownSingle from '../../components/DropDownSingle.vue'
import TreeSingle from '../../components/TreeSingle.vue'
import {selectMenuTreeList, menuList, menuAdd, menuUpdate, delMenuMore, delMenu} from '../../api/system'
export default {
  name: 'Menu',
  components: { TreeSingle, DropDownSingle },
  data () {
    return {
      expandRowKeys: [],
      loading: true,
      showAdd: false,
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      tableData: [],
      title: '',
      editCheckId: 0,
      menuData: [],
      judgeData: [
        {name: '是', value: 2},
        {name: '否', value: 1}
      ],
      search: {
        value: ''
      },
      mType: 1,
      item: {
        code: '',
        icon: '',
        id: '',
        ismenu: '',
        name: '',
        num: '',
        pid: '',
        url: ''
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData: function () {
      selectMenuTreeList().then(res => {
        console.log(res)
        this.menuData = [
          {
            id: -1,
            name: '无'
          },
          res.data
        ]
        console.log(this.menuData)
        this.title = this.menuData[0].name
        this.handleSearch()
      }).catch(err => {
        console.log(err)
      })
    },
    handleSearch: function () {
      console.log(this.search)
      this.loading = true
      let body = {
        keywork: this.search.value
      }
      console.log(body)
      menuList(body).then(res => {
        console.log(res)
        this.tableData = res.data
        this.loading = false
        console.log(this.expandRowKeys)
      }).catch(err => {
        console.log(err)
      })
    },
    handleSelectionChange: function (val) {
      console.log(val)
      this.idList = []
      val.map((data) => {
        this.idList.push(data.id)
      })
      this.all = this.idList.length === this.tableData.length
    },
    handleExpandChange: function (a, b) {
      if (b) {
        this.expandRowKeys.push(a.id)
      } else {
        let list = []
        let arr = this.expandRowKeys
        arr.map(data => {
          if (data !== a.id) {
            list.push(data)
          }
        })
        this.expandRowKeys = list
      }
      console.log(this.expandRowKeys)
    },
    deleteSingle: function (id) {
      console.log(id)
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        let body = {
          menuId: this.id
        }
        delMenu(body).then(res => {
          console.log(res)
          this.show = false
          this.id = ''
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.getData()
        }).catch(err => {
          console.log(err)
        })
      } else {
        let body = {
          menuIdLs: this.idList.join()
        }
        console.log(body)
        delMenuMore(body).then(res => {
          console.log(res)
          this.getData()
          this.all = false
          this.idList = []
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
        }).catch(err => {
          console.log(err)
        })
      }
    },
    showAddModal: function (mType, data) {
      this.mType = mType
      if (mType === 1) {
        this.title = '无'
        this.editCheckId = -1
        this.item = {
          code: '',
          icon: '',
          ismenu: 2,
          name: '',
          num: '',
          pcode: '',
          url: ''
        }
      } else if (mType === 2) {
        this.title = data.pname || '顶级'
        this.editCheckId = data.pid === 0 ? -1 : data.pid
        this.item = {
          id: data.id,
          code: data.code,
          icon: data.icon,
          ismenu: data.ismenu,
          name: data.name,
          num: data.num,
          pcode: data.pid,
          url: data.url
        }
      }
      this.showAdd = true
    },
    cancelAdd: function () {
      this.showAdd = false
    },
    confirmAdd: function () {
      if (this.item.code === '') {
        this.$message({
          message: '请输入菜单编号!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (this.item.name === '') {
          this.$message({
            message: '请输入菜单名称!',
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        } else {
          if (this.item.url === '') {
            this.$message({
              message: '请输入请求地址!',
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
          } else {
            if (this.mType === 1) {
              let body = this.item
              console.log(body)
              menuAdd(body).then(res => {
                console.log(res)
                this.$message({
                  message: '添加成功!',
                  type: 'warning',
                  center: 'true',
                  duration: '1000'
                })
                this.getData()
                this.showAdd = false
              }).catch(err => {
                console.log(err)
              })
            } else if (this.mType === 2) {
              let body = this.item
              console.log(body)
              menuUpdate(body).then(res => {
                console.log(res)
                this.$message({
                  message: '修改成功!',
                  type: 'warning',
                  center: 'true',
                  duration: '1000'
                })
                this.getData()
                this.showAdd = false
              }).catch(err => {
                console.log(err)
              })
            }
          }
        }
      }
    },
    showInfo: function (data) {
      console.log(data)
      this.item.ismenu = data.value
    },
    showTreeInfo: function (data) {
      console.log(data)
      this.item.pcode = data.id === -1 ? '' : data.id
    }
  }
}
</script>

<style scoped>
  @import "System.css";
</style>



// WEBPACK FOOTER //
// src/page/system/Menu.vue